module.exports = __webpack_public_path__ + "static/media/a_friendly_reminder.1975c5db.png";